import { ChangeDetectionStrategy, Component } from "@angular/core";

import { BackInStockFacade } from "@hermes/states/back-in-stock";

@Component({
    selector: "h-call-to-action-notify-me",
    templateUrl: "./call-to-action-notify-me.component.html",
    styleUrls: ["./call-to-action-notify-me.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallToActionNotifyMeComponent {
    constructor(public backInStockFacade: BackInStockFacade) {}

    public openBackInStock(): void {
        this.backInStockFacade.openBackInStock();
    }
}
